import translationObject from '../../../assets/locales/messages_en.json';
import {
  VIDEO_MAKER_FEATURE,
  MAXIMUM_EMAIL_LEGACY,
  MAXIMUM_EMAIL,
} from './content_keys';

export const createArrayOfElements = (
  shouldHideVideoMaker: boolean,
  showAscendMonetizationChanges: boolean,
) => {
  return Object.entries(translationObject).filter(
    (key) =>
      (!shouldHideVideoMaker || !key[0].includes(VIDEO_MAKER_FEATURE)) &&
      !key[0].includes(
        showAscendMonetizationChanges ? MAXIMUM_EMAIL_LEGACY : MAXIMUM_EMAIL,
      ),
  );
};
